import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { DialogContainer, FTLHeader } from "ftl-dashboards-ui-kit";
import { Box } from "@material-ui/core";
import { FTLSideMenu } from "ftl-dashboards-ui-kit";
import { SnackbarContainer } from "ftl-dashboards-ui-kit";
import { dialogService, useGlobalStoreState } from "ftl-dashboards-core";
import { useHistory } from "react-router-dom";
import { useAuthContext } from "ftl-auth-module";
export const FTLBaseLayout = ({ style, children, onSignOut, title, items, toHomeUrl, }) => {
    const [sideMenuWidth, setSideMenuWidth] = useState(245);
    const { profile } = useGlobalStoreState();
    const { state, dispatch } = useAuthContext();
    const history = useHistory();
    const profileHasData = Boolean(profile.id);
    const onSubmitDialog = useCallback(() => {
        dispatch({
            type: "SIGN_OUT",
        });
        dialogService.closeDialog();
    }, [onSignOut, dispatch]);
    useEffect(() => {
        onSignOut && onSignOut();
        if ("serviceWorker" in navigator) {
            caches.keys().then(function (keyList) {
                return Promise.all(keyList.map((key) => {
                    if (key.search(/v2/) === -1) {
                        return caches.delete(key);
                    }
                }));
            });
        }
    }, [state.isAuth]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FTLHeader, { logoLink: toHomeUrl, profileImageUrl: profile.profileImageUrl, title: title, profileMenuItems: [
                {
                    label: "Личные данные",
                    onClick: () => history.push("/profile", { tabIndex: 0 }),
                    isDisabled: !profileHasData,
                },
                {
                    label: "Контактные данные",
                    onClick: () => history.push("/profile", { tabIndex: 1 }),
                    isDisabled: !profileHasData,
                },
                {
                    label: "Безопасность",
                    onClick: () => history.push("/profile", { tabIndex: 2 }),
                    isDisabled: !profileHasData,
                },
                {},
                {
                    label: "Выйти",
                    onClick: () => {
                        dialogService.showDialog({
                            title: "Смена аккаунта",
                            onSubmit: onSubmitDialog,
                            children: "Вы действительно хотите выйти из данной учётной записи?",
                        });
                    },
                },
            ] }),
        React.createElement(Box, { width: "100%", display: "flex" },
            React.createElement(FTLSideMenu, { onMinimize: (width) => {
                    setSideMenuWidth(width);
                }, items: items }),
            React.createElement(Box, { display: "flex", width: "100%", flexGrow: "1", height: "calc(100vh - 56px)", style: Object.assign({ overflowY: "auto", overflowX: "hidden" }, style) },
                React.createElement(Box, { width: "100%", display: "flex", flexDirection: "column", pr: 10, pl: 10, mt: 6 },
                    children,
                    React.createElement(SnackbarContainer, { style: {
                            marginLeft: sideMenuWidth,
                            transition: "margin-left 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                        } }),
                    React.createElement(DialogContainer, null))))));
};
//# sourceMappingURL=index.js.map